const moneyFormat = '${{amount}}';
// Source: https://gist.github.com/stewartknapman/8d8733ea58d2314c373e94114472d44c
export const formatMoney = function (cents: number | string, format: string = moneyFormat) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }
  let value = '';
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

  function defaultOption(opt: any, def: any) {
    return typeof opt == 'undefined' ? def : opt;
  }

  function formatWithDelimiters(
    number: number,
    precision?: number,
    thousands?: string,
    decimal?: string
  ) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) {
      return 0;
    }

    const numberString = (number / 100.0).toFixed(precision);

    const parts = numberString.split('.');
    const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    const cents = parts[1] ? decimal + parts[1] : '';

    return dollars + cents;
  }

  switch (format.match(placeholderRegex)![1]) {
    case 'amount':
      value = formatWithDelimiters(cents as number, 2) || '';
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents as number, 0) || '';
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents as number, 2, '.', ',') || '';
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents as number, 0, '.', ',') || '';
      break;
  }

  return format.replace(placeholderRegex, value);
};
